import { Application } from '@/types/application';
import { findSubroutine } from './application';

export const deleteBlock = (application: Application, subroutineId: number, blockId: number): Application => {
  delete application.blocks.nodes[blockId];
  delete application.blocks.connections[blockId];
  delete application.blocks.details[blockId];
  delete application.blocks.layouts[blockId];
  delete application.blocks.portoptions[blockId];

  const subroutines = application.subroutines.map((currentSubroutine) => {
    if (currentSubroutine.id === subroutineId) {
      if (currentSubroutine.startblock === blockId) {
        currentSubroutine.args = [];
        currentSubroutine.arg_bindings = [];
        currentSubroutine.return_types = [];
        delete currentSubroutine.event_args;
        delete currentSubroutine.event_arg_bindings;
        delete currentSubroutine.startblock;
      }

      currentSubroutine.nodes.forEach((node) => {
        application.blocks.connections[node]?.forEach((connection) => {
          if (connection.dst === blockId) {
            connection.dst = null;
          }
        });
      });

      return { ...currentSubroutine, nodes: currentSubroutine.nodes.filter((id) => id !== blockId) };
    } else {
      return currentSubroutine;
    }
  });

  return { ...application, subroutines: subroutines };
};

export const deleteVariables = (application: Application, subroutineId: number): Application => {
  delete application.variables.local[subroutineId];

  return application;
};

export const deleteSubroutine = (application: Application, subroutineId: number): Application => {
  findSubroutine(application.subroutines, subroutineId)?.nodes.map((blockId) =>
    deleteBlock(application, subroutineId, blockId)
  );
  deleteVariables(application, subroutineId);

  return {
    ...application,
    subroutines: application.subroutines.filter((subroutine) => subroutine.id !== subroutineId)
  };
};

export const deletePromptGroup = (application: Application, id: number): Application => {
  application.prompts = application.prompts.map((prompt) => {
    if (prompt.promptGroup === id) {
      return { ...prompt, promptGroup: 0 };
    } else {
      return prompt;
    }
  });
  return {
    ...application,
    promptGroups: application.promptGroups?.filter((promptGroup) => promptGroup.id !== id)
  };
};
